import sectionCardAccordionsCss from '../css-snippets/section-card-accordions';
const html = `

<style>${sectionCardAccordionsCss}</style>
<div id="card-container-unique-id" data-id="unique-id" data-attribute="card-container" data-background="#FFFFFF" data-top-padding="true" data-bottom-padding="true"
  style="background-color: rgb(255, 255, 255);">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="wrap-card container">
      <div data-attribute="card-item-content" data-order="2" class="card-left" data-style-center-y="true"
        style="order: 2;">
        <div data-attribute="card-rated-row" data-show-rating="false" style="display: none;">
          <div class="wrap-rated">
            <div data-attribute="rating-stars" data-value="4" class="wrap-stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
            </div>
            <div data-attribute="rating-text" class="wrap-rating">Rated 4.9/5 by 12,000+ happy pet owners
            </div>
          </div>
        </div>
        <div data-attribute="card-content" class="card-content">
          <div data-attribute="card-title">
            <h2><strong>120-DAY GROWTH GUARANTEE—ZERO RISK</strong></h2>
          </div>
          <div data-attribute="card-survay" data-show-survay="false" class="card-survay" style="display: none;">
            <div data-attribute="item-survay" class="wrap-survay-item">
              <div class="left-item" style="color: #d1d5db;">
                <svg class="size-full" viewBox="0 0 100 100">
                  <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50"
                    cy="50" r="40"></circle>
                  <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8"
                    fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)"
                    stroke-dasharray="251.32741228718345" stroke-dashoffset="25.132741228718338"></circle>
                </svg>
                <div class="wrap-percent"><span data-attribute="percent-survay">90</span> %</div>
              </div>
              <div data-attribute="description-survay" class="right-item">
                of drivers reported a more stable and secure hold compared to suction or vent mounts —
                especially on bumpy or curved roads.
              </div>
            </div>
          </div>
          <div data-attribute="card-description">
            <p>Every AlphaInfuse™ purchase is backed by a money-back promise. If you don’t see thicker, fuller hair,
              simply return it within 120 days—no questions asked.</p>
          </div>
        </div>
        <div data-attribute="card-btn-row" data-show-btn="false" class="row-btn" style="display: none;">
          <a data-attribute="card-btn" class="card-btn" href="#">👉 Get It Now</a>
          <div data-attribute="sub-btn" class="sub-btn"></div>
        </div>
        <div data-attribute="card-accordions" data-show-accordion="true" style="display: block;">
          <div data-attribute="card-accordion" class="wrap-accordion">
            <div data-attribute="accordion-title" class="accordion-title">
              <div data-attribute="accordion-title-text">Guarantee Details</div>
              <div class="accordion-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-chevron-down-icon lucide-chevron-down">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </div>
            </div>
            <div data-attribute="accordion-content" class="accordion-content">
              <div data-attribute="accordion-text" class="accordion-text">We're so confident in AlphaInfuse™ that we don't
                want you to spend a dime until you're 100% sure it works for you.

                That's why we offer a 120-day, no-questions-asked guarantee.

                If you don't see the results you expect, we'll issue a full refund—no hassle, no risk. Simply put, you only pay if it delivers real, life-changing results. And based on our track record, we're certain it will.
              </div>
            </div>
          </div>
          <div data-attribute="card-accordion" class="wrap-accordion">
            <div data-attribute="accordion-title" class="accordion-title">
              <div data-attribute="accordion-title-text">Guarantee Details</div>
              <div class="accordion-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-chevron-down-icon lucide-chevron-down">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </div>
            </div>
            <div data-attribute="accordion-content" class="accordion-content">
              <div data-attribute="accordion-text" class="accordion-text">We're so confident in AlphaInfuse™ that we don't
                want you to spend a dime until you're 100% sure it works for you.

                That's why we offer a 120-day, no-questions-asked guarantee.

                If you don't see the results you expect, we'll issue a full refund—no hassle, no risk. Simply put, you only pay if it delivers real, life-changing results. And based on our track record, we're certain it will.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-attribute="card-item-image" data-order="1" class="card-right" style="order: 1;">
        <div class="wrap-img">
          <img loading="lazy" data-attribute="card-image" class="card-image"
            src="https://cdn.skyfastimg.com/images/2025/10/15/image-68ef42ffebf0c8b7c0e0f006.webp?w=500&h=50&q=80"
            alt="">
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
